import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const ProgressSpinner = () => (
    <Box
        display='flex'
        alignItems='center'
        justifyContent='center'
        sx={{ width: '100%', height: '100%', background: 'rgba(0,0,0,0.1)' }}
        position='fixed'
        top='0'
        left='0'
        zIndex='4'
    >
        <Box display='flex' alignItems='center' justifyContent='center' padding='8px'>
            <CircularProgress />
        </Box>
    </Box>
);

export default ProgressSpinner;
